<template>
  <div class="right-panel">
    <v-row class="ma-0 px-0 py-4">
      <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="6">
        <VAutoComplete
          v-model="specialities"
          :items="specialitiesList"
          item-text="name"
          item-value="_id"
          placeholder="Search speciality"
          @change="findDoctors"
          clearable
        />
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="6">
        <VAutoComplete
          v-model="clinic"
          :items="clinicList"
          item-text="name"
          item-value="_id"
          placeholder="Search clinic"
          @change="findDoctors"
          clearable
        />
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="6">
        <location-field
          v-model="location"
          placeholder="Search location"
          prepend-inner-icon="location_searching"
          hide-details
          @change="findDoctors"
          solo
        />
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          label="Search by name"
          v-debounce:1s="findDoctors"
          :debounce-events="['click', 'keydown']"
          solo
          hide-details
          single-line
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card-title
      v-if="$vuetify.breakpoint.xsOnly"
      class="pa-2 recommended-text"
    >
      Recommended doctors nearby you
    </v-card-title>
    <v-card-title v-else class="pa-2">
      Recommended doctors nearby you, still you can filter the best doctors
    </v-card-title>
    <v-row class="ma-0">
      <v-col class="pa-0">
        <v-row class="ma-0 scroll-box">
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="5"
            lg="5"
            xl="5"
            v-if="$vuetify.breakpoint.xsOnly"
          >
            <v-btn
              @click="showMap = true"
              v-show="!showMap"
              class="px-0 reset-button open-close-map-btn"
              text
              color="#2F4C67"
              >Open map</v-btn
            >
            <v-btn
              @click="showMap = false"
              v-show="showMap"
              class="px-0 reset-button open-close-map-btn"
              text
              color="red"
              >Close map</v-btn
            >
            <div v-show="showMap" style="position:relative" class="py-2">
              <v-sheet color="white" class="fixed-map-title pa-2" rounded>
                Search as you move the map
              </v-sheet>
              <div id="map" class="map-bx"></div>
            </div>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            lg="6"
            xl="4"
            v-for="(doctor, index) in doctorList"
            :key="doctor._id + index"
            :class="$vuetify.breakpoint.xsOnly ? 'pr-2 pl-2' : ''"
          >
            <v-card
              outlined
              @mouseenter="bounceMarker(doctor, true)"
              @mouseleave="bounceMarker(doctor, false)"
              @click="bookAppointment(doctor)"
            >
              <v-list>
                <v-list-item>
                  <v-list-item-avatar
                    size="40"
                    v-if="
                      doctor.media && doctor.media.length && doctor.media[0].url
                    "
                  >
                    <img :src="doctor.media[0].url" />
                  </v-list-item-avatar>
                  <v-list-item-avatar size="36" class="avatar-img" v-else>{{
                    doctor | initial
                  }}</v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="card-title">
                      {{ doctor.firstName }}
                      {{ doctor.lastName }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="card-subtitle">
                      {{ doctor.roles.name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-subtitle class="card-subtitle-1">
                    {{
                      doctor.bookingTypes[0] &&
                      doctor.bookingTypes[0].availability.length > 0 &&
                      doctor.bookingTypes[0].availability[0].name
                        ? doctor.bookingTypes[0].availability[0].name
                        : "Not available"
                    }}
                  </v-list-item-subtitle>
                  <div
                    v-if="
                      doctor.bookingTypes[0] &&
                        doctor.bookingTypes[0].workplaces.length > 0
                    "
                    class="d-flex hospital-box"
                  >
                    <v-icon
                      small
                      class="mdi mdi-hospital-box-outline  mr-1"
                    ></v-icon>
                    <v-list-item-subtitle class="text-format">{{
                      doctor.bookingTypes[0].workplaces[0].name
                    }}</v-list-item-subtitle>
                  </div>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12">
            <infinite-loading
              :identifier="infiniteId"
              @infinite="infiniteHandler"
            >
              <div slot="no-more"></div>
              <div slot="no-results" class="headline">
                <v-card flat>
                  <v-card-title
                    class="justify-center"
                    :style="
                      $vuetify.breakpoint.xsOnly
                        ? 'font-size: 16px; padding-right: 0px; padding-left: 0px;'
                        : ''
                    "
                  >
                    No doctors found that match your search.
                  </v-card-title>
                  <v-card-actions class="justify-center">
                    <v-btn
                      @click="resetFilters"
                      color="#F44336"
                      outlined
                      class="reset-button ma-0"
                      >Reset filters</v-btn
                    >
                  </v-card-actions></v-card
                >
              </div>
            </infinite-loading>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col
        cols="12"
        xs="12"
        sm="12"
        md="5"
        lg="5"
        xl="5"
        v-if="$vuetify.breakpoint.xsOnly"
      >
        <v-btn
          @click="showMap = true"
          v-show="!showMap"
          class="px-0 reset-button open-close-map-btn"
          text
          color="#2F4C67"
          >Open map</v-btn
        >
        <v-btn
          @click="showMap = false"
          v-show="showMap"
          class="px-0 reset-button open-close-map-btn"
          text
          color="red"
          >Close map</v-btn
        >
        <div v-show="showMap" style="position:relative" class="py-2">
          <v-sheet color="white" class="fixed-map-title pa-2" rounded>
            Search as you move the map
          </v-sheet>
          <div id="map" class="map-bx"></div>
        </div>
      </v-col> -->
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="5"
        lg="5"
        xl="5"
        v-if="$vuetify.breakpoint.smAndUp"
      >
        <div style="position:relative">
          <v-sheet color="white" class="fixed-map-title pa-2" rounded>
            Search as you move the map
          </v-sheet>
          <div id="map" class="map-bx"></div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import InfiniteLoading from "vue-infinite-loading";
import { VLocation, VAutoComplete } from "@/components/inputs";
import { DoctorService, AuthService } from "@/services";
import store from "../../store";
export default {
  name: "FindDoctor",
  components: {
    InfiniteLoading,
    LocationField: VLocation,
    VAutoComplete
  },
  data() {
    return {
      loading: false,
      map: null,
      page: 1,
      perPage: 500,
      search:
        this.$route.params && this.$route.params.search != ""
          ? this.$route.params.search
          : null,
      coordinates: [],
      findDoctor: false,
      hover: false,
      location: {
        name: null,
        street1: null,
        street2: null,
        street3: null,
        city: null,
        state: null,
        postcode: null,
        country: null,
        coordinates: []
      },
      userLatLng: null,
      mapOptions: {
        radius: null,
        zoomLevel: 10,
        bounds: null,
        center: null
      },
      doctorList: [],
      marker: null,
      infiniteId: +new Date(),
      markers: [],
      infoWindow: new window.google.maps.InfoWindow({
        disableAutoPan: true
      }),
      markerCluster: null,
      specialitiesList: [],
      specialities:
        this.$route.params && this.$route.params.speciality != null
          ? this.$route.params.speciality
          : null,
      clinicList: [],
      clinic:
        this.$route.params && this.$route.params.clinic != null
          ? this.$route.params.clinic
          : null,
      show: [],
      showMap: false
    };
  },
  mounted() {
    this.initMap();
    this.getSpecialityList();
    this.getClinicList();
  },
  watch: {
    showMap() {
      this.infiniteId += 1;
    }
  },
  methods: {
    initMap() {
      if (!this.userLatLng) {
        const loggedUserDetails = store.state.user;
        if (
          loggedUserDetails &&
          loggedUserDetails.user &&
          loggedUserDetails.user.address &&
          loggedUserDetails.user.address.length > 0 &&
          loggedUserDetails.user.address[0].location
        ) {
          if (
            loggedUserDetails.user.address[0].location &&
            loggedUserDetails.user.address[0].location.coordinates
          ) {
            this.userLatLng =
              loggedUserDetails.user.address[0].location.coordinates;
          } else if (
            loggedUserDetails.user.address[1].location &&
            loggedUserDetails.user.address[1].location.coordinates
          ) {
            this.userLatLng =
              loggedUserDetails.user.address[1].location.coordinates;
          } else {
            this.userLatLng = [-0.118092, 51.509865];
          }
        } else {
          this.userLatLng = [-0.118092, 51.509865];
        }
      }
      this.map = new window.google.maps.Map(document.getElementById("map"), {
        zoom: this.$vuetify.breakpoint.xsOnly ? 5 : 10,
        minZoom: 6,
        maxZoom: 18,
        center:
          this.location && this.location.coordinates[0]
            ? this.getLatLng(this.location.coordinates)
            : this.mapOptions.center || this.getLatLng(this.userLatLng),
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        clickableIcons: false
      });
      window.google.maps.event.addListener(this.map, "idle", () => {
        this.setMapOptions();
        this.findDoctor = true;
        this.searchDoctors();
      });
      this.map.addListener("click", () => {
        this.infoWindow.close();
      });
    },
    setMapOptions() {
      var bounds = this.map.getBounds();
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();
      const center = this.map.getCenter();
      this.mapOptions.zoom = this.map.getZoom();
      if (center) {
        this.mapOptions.center = {
          lat: center.lat(),
          lng: center.lng()
        };
      }
      if (bounds && northEast && southWest) {
        this.mapOptions.northEast = [northEast.lng(), northEast.lat()];
        this.mapOptions.southWest = [southWest.lng(), southWest.lat()];
      }
    },
    async infiniteHandler($state) {
      if (this.findDoctor) {
        const params = {
          limit: parseInt(this.perPage),
          skip:
            parseInt(this.page) * parseInt(this.perPage) -
            parseInt(this.perPage),
          search: this.search,
          coordinates:
            this.location &&
            this.location.coordinates[0] &&
            this.location.coordinates[1]
              ? this.location.coordinates
              : this.getLatLng(this.mapOptions.center) || this.userLatLng,
          northEast: this.mapOptions.northEast,
          southWest: this.mapOptions.southWest,
          isPatient: true,
          speciality: this.specialities,
          clinic: this.clinic,
          available: true
        };
        if (!this.showMap && this.$vuetify.breakpoint.xsOnly) {
          delete params.coordinates;
          delete params.northEast;
          delete params.southWest;
        }
        const doctorList = await DoctorService.findDoctor(params);
        if (doctorList.data.data.length > 0) {
          // this.doctorList.push(...doctorList.data.data);
          for (let i = 0; i < doctorList.data.data.length; i += 1) {
            const findObj = this.doctorList.find(obj => {
              return (
                obj._id === doctorList.data.data[i]._id &&
                obj.bookingTypes[0].workplaceId ===
                  doctorList.data.data[i].bookingTypes[0].workplaceId
              );
            });
            if (!findObj) {
              this.doctorList.push(doctorList.data.data[i]);
            }
            Vue.set(doctorList.data.data[i], "show", false);
          }
          $state.loaded();
          $state.complete();
          this.clearMarkers();
          this.prepareMarker();
        } else {
          $state.complete();
        }
      }
    },
    findDoctors() {
      this.initMap();
    },
    searchDoctors() {
      this.doctorList = [];
      this.page = 1;
      this.infiniteId += 1;
    },
    resetFilters() {
      const resetLocation = {
        name: null,
        street1: null,
        street2: null,
        street3: null,
        city: null,
        state: null,
        postcode: null,
        country: null,
        coordinates: []
      };
      this.location = Object.assign({}, resetLocation);
      this.specialities = null;
      this.clinic = [];
      this.search = null;
      this.findDoctors();
    },
    bookAppointment(doctor) {
      const appointmentUrl =
        "book-appointment/" +
        doctor._id +
        "/" +
        doctor.bookingTypes[0].workplaceId;
      this.$store.dispatch("user/setBooking", appointmentUrl);
      const isVerified = store.state.user;
      if (isVerified.isBooking && isVerified.isUserLoggedIn) {
        this.$router.push(appointmentUrl);
      } else {
        // this.$router.push("/login");
        this.$router.push(appointmentUrl);
      }
    },
    // clear all marker from map
    clearMarkers() {
      if (this.markers.length > 0) {
        if (this.markerCluster) {
          this.markerCluster.clearMarkers();
        }
        for (var i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];
      }
    },
    prepareMarker() {
      this.markers = [];
      this.doctorList.forEach(doctor => {
        if (doctor.bookingTypes[0].workplaces[0].location.coordinates) {
          const marker = new window.google.maps.Marker({
            position: {
              lat: doctor.bookingTypes[0].workplaces[0].location.coordinates[1],
              lng: doctor.bookingTypes[0].workplaces[0].location.coordinates[0]
            },
            //label: doctor.firstName.charAt(0).toUpperCase(),
            map: this.map,
            id: doctor._id + doctor.bookingTypes[0].workplaceId,
            title: `${doctor.firstName} ${doctor.lastName}`,
            text: "text"
          });
          marker.addListener("click", () => {
            this.infoWindow.setContent(this.informationWindow(doctor));
            this.infoWindow.open(this.map, marker);
          });
          this.markers.push(marker);
        }
      });
      /*   this.markerCluster = new window.MarkerClusterer(this.map, this.markers, {
        imagePath:
          "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
      }); */
    },
    bounceMarker(doctor, action) {
      const id = doctor._id + doctor.bookingTypes[0].workplaceId;
      const selectedMarker = this.markers.find(value => value.id === id);
      this.infoWindow.close();
      if (selectedMarker) {
        if (!action) {
          selectedMarker.setAnimation(null);
        } else {
          selectedMarker.setAnimation(window.google.maps.Animation.BOUNCE);
        }
      }
    },
    informationWindow(doctor) {
      return `<a href="/book-appointment/${doctor._id}/${
        doctor.bookingTypes[0].workplaceId
      }"><div class="layout justify-space-around align-center wrap">
      <div class="v-image__image--cover" 
      style="height:40px;min-width:40px;width:40px;
      background-image: url(&quot;${
        doctor.media && doctor.media.length && doctor.media[0].url
          ? doctor.media[0].url
          : "https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300207502.png"
      }&quot;); background-position: center center;">
      </div>
      <div class="pt-1"><strong> ${doctor.firstName} ${doctor.lastName}</strong>
      <div>${doctor.roles.name}</div>
      </div>
      </div> `;
    },
    async getSpecialityList() {
      const response = await AuthService.getSpeciality();
      this.specialitiesList = response.data;
    },
    async getClinicList() {
      const clinicData = await AuthService.getClinics();
      this.clinicList = clinicData.data;
    },
    expandDoctorDetails(doctor, index) {
      doctor.show = !doctor.show;
      if (this.$refs["doctorExpansionPanel_" + index].length > 0) {
        this.$refs["doctorExpansionPanel_" + index][0].showDetails(doctor.show);
      }
    }
  }
};
</script>

<style>
#map {
  height: calc(100vh - 180px);
}
.speciality-select .success--text {
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 0px;
  top: 0 !important;
  position: inherit;
}
.v-expansion-panel-header {
  position: absolute;
  min-height: 0 !important;
  bottom: 0px;
}
.v-expansion-panel-content__wrap {
  padding: 0px;
}
.speciality-list li span {
  position: relative;
  left: -7px;
  color: rgb(52, 68, 82);
}
.speciality-list li {
  color: #fcae00;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin: 0px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px;
  display: none;
}
.card-title {
  color: #344452;
  text-transform: capitalize;
  font-family: "Now Alt", sans-serif;
  font-size: 14px;
  font-weight: 500;
}
.card-subtitle {
  font-family: "Now Alt", sans-serif;
  font-size: 12px;
  font-weight: 300;
}
.card-subtitle-1 {
  font-family: "Now Alt", sans-serif;
  font-size: 12px;
  font-weight: 400;
}
.map-bx {
  border: 1px solid #e0e0e0;
}
.scroll-box {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}
.fixed-map-title {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  white-space: nowrap;
  text-align: center;
  margin-top: 8px;
  padding: 12px 16px;
  transform: translateX(-50%);
}
.reset-button {
  text-transform: none;
}
.content-text {
  font-family: "Now Alt", sans-serif;
}
.v-card {
  transition: opacity 0.4s ease-in-out;
}
.avatar-img {
  font-size: 24px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  padding-bottom: 2px;
  padding-left: 1px;
  color: #000000 !important;
  border: 1px solid #d6e0ef !important;
}
.hospital-box {
  justify-content: end !important;
}
.text-format {
  max-width: 136px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommended-text {
  font-size: 16px;
}
.open-close-map-btn {
  font-size: 16px !important;
}
</style>
